<template>
    <category-layout>
        <div class="page">  
            <loading v-if="!$store.getters.portfolioLoaded" />
            <div v-else class="portfolio-slider">
                <button class="uk-back">
                    <router-link :to="`/work`">
                        <whiteBackArrow class="back-arrow" />
                    </router-link>
                </button>
                
                <div v-if="portfolioPosts" class="category-slider">
                    <!-- <div ref="mobileIndicator" class="mobile-indicator uk-hidden@s">
                        <fast-forward class="ff-icon prev"/>
                        <h2 class="white">Slide</h2>
                        <fast-forward class="ff-icon next"/>
                    </div> -->
                    <swiper :options="portfolioSwiper" class="category-slider-container swiper-container swiper-height-full" ref="parentSwiper">
                        <swiper-slide v-for="(slide, j) in portfolioPosts"
                                    :key="j"
                                    :ref="slide.title + j"
                                    class="swiper-slide">
                            <div class="category-description is-collapsed" uk-grid>
                                <div style="height: 3vh" class="uk-width-1-5">
                                    <button
                                        class="uk-button uk-button-link uk-float-right"
                                        @click="ukToggle(slide.title + j)">
                                        <whiteChevronDown class="arrow-down"/>
                                    </button>
                                </div>
                                <div class="uk-width-4-5">
                                    <p class="project-title" v-text="slide.title"></p>
                                    <div class="project-extra is-hidden">
                                        <p v-if="slide.description" v-html="slide.description"></p>
                                    </div>
                                </div>
                            </div>

                        <div class="category-image">
                            <img v-for="(images) in slide.images" :key="images.sys.id" :src="images.fields.file.url" :alt="images.fields.file.description ? images.fields.file.description : 'Fallback alt'" />
                        </div>

                        </swiper-slide>
                        <div class="swiper-button-prev" slot="button-prev">
                            <whiteSliderMouthLeft class="slider-btn prev-Mouth"/>
                        </div>
                        <div class="swiper-button-next" slot="button-next">
                            <whiteSliderMouthRight class="slider-btn next-Mouth"/>
                        </div>
                    </swiper>
                </div>
                <div v-else>
                    Nothing to load!
                </div>
            </div>
        </div>
    </category-layout>
</template>

<script>
import whiteSliderMouthRight from '@/assets/img/white-slider-mouth-right.svg'
import whiteSliderMouthLeft from '@/assets/img/white-slider-mouth-left.svg'
import whiteBackArrow from '@/assets/img/white-back-arrow.svg'
import whiteChevronDown from '@/assets/img/white-chevron-down.svg'
import fastForward from '@/assets/img/fast-forward.svg'

export default {
    components: {
        whiteSliderMouthRight,
        whiteSliderMouthLeft,
        whiteBackArrow,
        whiteChevronDown,
        fastForward
    },
    name: 'category',
    data () {
        return {
            taller: false,
            color: '',
            portfolioSwiper: {
                // init: false,
                preloadImages: true,
                direction: 'horizontal',
                loop: false,
                slidesPerView: 1,
                roundLengths: true,
                spaceBetween: 0,
                grabCursor: true,
                simulateTouch: true,
                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
        }
    },
    computed: {
        category () {
            return this.$route.params.id
        },
        swiper () {
            return this.$refs.parentSwiper.swiper
        },
        portfolioPosts () {
            const posts = []

            if (this.$store.getters.portfolioLoaded) {
                // Define Colour
                this.$store.getters.categories.forEach(cat => {
                    if (cat.fields.categorySlug === this.$route.params.id) this.color = cat.fields.categoryColour.fields.colourSlug
                })
            }
            // Define Posts
            if (this.$store.getters.portfolioLoaded && this.$store.getters.portfolio.posts) {
                this.$store.getters.portfolio.posts.items.forEach(element => {
                    if (
                        this.category 
                        && (element.fields.category && element.fields.category.fields) 
                        && (this.category === element.fields.category.fields.categorySlug)
                    ) {
                        const obj = {
                            title:  element.fields.title,
                            description: element.fields.description,
                            images: element.fields.portfolioImages,
                            category: {
                                name: element.fields.category.fields.categoryName,
                                slug: element.fields.category.fields.categorySlug,
                                color: element.fields.category.fields.categoryColour.fields.colourSlug
                            }
                        }
                        posts.push(obj)
                    }
                }) 
            }
            return (posts.length === 0) ? null : posts
        }
    },
    methods: {
        ukToggle (hash) {
            const projectContainer = this.$refs[hash][0].$el.firstElementChild
            
            if (projectContainer.classList.contains('is-collapsed')) {
                projectContainer.classList.remove('is-collapsed')
                let toggleArrow = projectContainer.getElementsByClassName("arrow-down")[0]
                toggleArrow.classList.add('arrow-reverse')
            } else {
                projectContainer.classList.add('is-collapsed')
                let toggleArrow = projectContainer.getElementsByClassName("arrow-down")[0]
                toggleArrow.classList.remove('arrow-reverse')
            }
        }
    },
    mounted () {
        setTimeout(() => {
            // console.log(this.$refs.mobileIndicator)
            this.$refs.mobileIndicator.classList.add('fadeOut')
        }, 0);
    }
}
</script>

<style lang="scss" scoped>
    $tongue-size: 120px;

    .page:before {
        height: 0;
        min-height: 0;
    }
    .category-slider,
    .category-slider-container {
        height: 100%;
        height: 100vh;
    }

    .category-image {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }

    .slider-btn{
        fill: white;
        width: 3vw;
    }
    .back-arrow{
        height: 5vh;
        color: $white;
        fill: $white;
    }
    .arrow-down{
        height: 2vh;
        color: $white;
        fill: $white;
        transform: rotate(180deg);
    }
    .arrow-reverse{
        transition: width 1s;
        transform: rotate(0);
    }
    // Parent Slide
    .category-slider-container {
        .swiper-slide {
            position: relative;
            overflow: hidden;
            background-position: 50% 50%;
            height: 100vh;
            width: 100vw;

            img {
                width: auto;
                margin: auto;
                max-width: 100%;
                height: auto;
            }
            .uk-button {
                margin-top: 1vh;
            }
        }

        .swiper-button-next {
            width: unset;
            height: auto;
            top: 50vh;
            background-image: none !important;
            right: 1vw;
        }
        .swiper-button-prev {
            width: unset;
            height: auto;
            top: 50vh;
            background-image: none;
            left: 1vw;
        }
    }

    .category-description {
        width: 100vw;
        @include mq($from: tablet) {
            width: 50vw;
        }
        @include mq($from: xlarge) {  
            width: 30vw;
        }
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 1vw;
        margin-left: 0 !important;
        background-color: $black;
        font-family: $global-font-mono;
        text-align: left;
        color: $white;
        transition: $transition;
        z-index: 99;

        &.is-collapsed {
            // Adjust negative element for height of top bar
            transform: translateY(calc(100% - 38px));
            transition: $transition;
            background-color: transparent;
            bottom: 1vw;
            .project-title {
                color: transparent;
                font-size: unset;
            }
        }
        .uk-button-link{
            color: inherit;
            float: left;
        }
        .project-title {
            color: $grey;
            margin-top: 1vw;
            text-decoration: underline;
        }

        .swiper-pagination-bullet {
            margin: 0 6px;
        }
    }

    .project-container,
    .project-image {
        background-image: none !important;
        background-size: contain;
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
    }
    .uk-back{
        left: 1vw;
        top: 2vh;
        position: absolute;
        background: transparent;
        border: none;
        outline: none;
        z-index: 99;
        a:hover{
            color: $white
        }
    }


    .mobile-indicator {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        width: 250px;
        height: 80px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(1.2);
        border-radius: 10px;
        background-color: $base-overlay;
        z-index: 3;
        pointer-events: none;
        opacity: 1;
        transition: opacity 0.25s;

        h2 {
            margin-top: 0;
            margin-left: 10px;
            margin-right: 10px;
        }
        .ff-icon {
            width: 48px;
            fill: white;
            &.next {
                transform: rotate(180deg);
            }
        }
    }

    .fadeOut {
        animation-duration: 0.25s !important;
        opacity: 0;
    }

    .fadeOut {
        animation-duration: 0.25s !important;
        opacity: 0;
    }

</style>




// WEBPACK FOOTER //
// src/pages/work/Category.vue